import React from 'react';
import { ClientsManagementProvider } from './context/clients-management-context';
import ClientsManagement from './clients-management';
import { BaseInternalFormFactory } from '../../base-internal-form/base-internal-form-factory';

const ClientsManagementFactory: React.FC = () => {
    return (
        <BaseInternalFormFactory pageTitle="Clientes">
            <ClientsManagementProvider>
                <ClientsManagement />
            </ClientsManagementProvider>
        </BaseInternalFormFactory>
    );
};

export default ClientsManagementFactory;